import type { IconSvgObject } from './types';

const SunsetIcon: IconSvgObject = [
  ["path", { d: "M9.5 7.5C9.99153 8.0057 11.2998 10 12 10M14.5 7.5C14.0085 8.0057 12.7002 10 12 10M12 10V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.3633 10.6357L16.9491 12.05", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 17H5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5.63657 10.6356L7.05078 12.0498", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M21 17H19", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M21 20H3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "5" }],
  ["path", { d: "M16 17C16 14.7909 14.2091 13 12 13C9.79086 13 8 14.7909 8 17", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "6" }]
];

export default SunsetIcon;
